import Errors from './Errors';

class Form {

	/**
	 * Create new form instanc
	 * @param  {object} data
	 */
	constructor(data) {
		this.originalData = data;

		for(let field in data){
			this[field] = data[field];
		}

		this.errors = new Errors;
	}

	/**
	 * Fetch all relevant data for the form
	 */
	data() {

		let data = {};

		for(let property in this.originalData) {
			data[property] = this[property];
		}

		// let data = Object.assign({}, this);

		delete data.originalData;
		delete data.errors;

		return  data;
	}

	/**
	 * Reset all the fields
	 */
	reset() {
		for (let field in this.originalData) {
			this[field] = '';
		}

		this.errors.clear();
	}

	get(url) {
		return this.submit('get', url);
	}
	post(url) {
		return this.submit('post', url);
	}
	patch(url) {
		return this.submit('patch', url);
	}
	delete(url) {
		return this.submit('delete', url);
	}

	/**
	 * Submit the form
	 * @param  {string} requestType
	 * @param  {string} url
	 */
	submit(requestType, url) {
		return new Promise((resolve, reject) => {
			axios[requestType](url, this.data())
				// .then(this.onSuccess.bind(this))
				.then(response => {
					this.onSuccess(response.data);

					resolve(response.data);
				})
				.catch(error => {
					this.onFail(error.response.data);

					reject(error.response.data);
				});
				// .catch(this.onFail.bind(this));
		});
	}

	/**
	 * Handle a successful form submission
	 * @return {object} data
	 */
	onSuccess(data) {
		// alert(data.message); //temporary

		this.reset();
	}

	/**
	 * handle the field form submission
	 * @param  {object} error
	 */
	onFail(errors) {
		this.errors.record(errors);
	}

}

export default Form;